import { render, staticRenderFns } from "./TextBoxController.vue?vue&type=template&id=22fcde6a&"
import script from "./TextBoxController.vue?vue&type=script&lang=js&"
export * from "./TextBoxController.vue?vue&type=script&lang=js&"
import style0 from "./TextBoxController.vue?vue&type=style&index=0&id=22fcde6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports